module.exports = __webpack_public_path__ + "img/wallet-fill.42889f01.svg";